/*====================================================
	In view animations.
====================================================*/
window.addEventListener('load', function () {
	// IntersectionObserver to know when an element is in view
	const sectionsReveal = document.querySelectorAll(
		'.scroll-reveal, .parent-reveal, [reveal-trigger-origin], [reveal-trigger-target], [reveal-play-video], [reveal-keyframe-animation]'
	);
	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					// Default scroll reveal with/without reveal delay.
					if (entry.target.classList.contains('scroll-reveal')) {
						let delay = 0;
						const delayClass = Array.from(entry.target.classList).find(cls => cls.startsWith('reveal-delay-'));
						if (delayClass) {
							delay = parseInt(delayClass.replace('reveal-delay-', ''));
						}
						setTimeout(function () {
							entry.target.classList.add('in-view');
						}, delay);
					}

					// Parent elements with/without reveal delay.
					if (entry.target.classList.contains('parent-reveal')) {
						let delay = 0;
						const delayClass = Array.from(entry.target.classList).find(cls => cls.startsWith('reveal-delay-'));
						if (delayClass) {
							delay = parseInt(delayClass.replace('reveal-delay-', ''));
						}
						setTimeout(function () {
							entry.target.classList.add('in-view');

							// Children elements with/without reveal delay.
							entry.target
							.querySelectorAll('.child-reveal')
							.forEach((child) => {
								let childDelay = 0;
								const childDelayClass = Array.from(child.classList).find(cls => cls.startsWith('reveal-delay-'));
								if (childDelayClass) {
									childDelay = parseInt(childDelayClass.replace('reveal-delay-', ''));
								}
								setTimeout(function () {
									child.classList.add('in-view');
								}, childDelay);
							});
						}, delay);
					}

					// Trigger target reveal.
					const triggerOrigin = entry.target.getAttribute('reveal-trigger-origin');
					if (triggerOrigin) {
						const target = document.querySelector(`[reveal-trigger-target="${triggerOrigin}"]`);
						if (target) {
							let delay = 0;
							const delayClass = Array.from(target.classList).find(cls => cls.startsWith('reveal-delay-'));
							if (delayClass) {
								delay = parseInt(delayClass.replace('reveal-delay-', ''));
							}
							setTimeout(function () {
								target.classList.add('in-view');
							}, delay);
						}
					}

					// Trigger keyframe animation.
					const keyframeAnimationClass = entry.target.getAttribute('reveal-keyframe-animation');
					if (keyframeAnimationClass) {
						let delay = 0;
						const delayClass = Array.from(entry.target.classList).find(cls => cls.startsWith('reveal-delay-'));
						if (delayClass) {
							delay = parseInt(delayClass.replace('reveal-delay-', ''));
						}
						// Apply the keyframe animation class with a delay
						setTimeout(function () {
							entry.target.classList.add(keyframeAnimationClass);
						}, delay);
					}

					// Play video on reveal.
					if (entry.target.hasAttribute('reveal-play-video')) {
						const video = entry.target.querySelector('video');
						if (video) {
							video.play();
						}
					}

				} else {
					// Remove .in-view class from repeat-reveal elements when not intersecting
					if (entry.target.classList.contains('repeat-reveal')) {
						entry.target.classList.remove('in-view');
					}
					if (entry.target.classList.contains('parent-reveal')) {
						entry.target.querySelectorAll('.child-reveal.repeat-reveal').forEach((child) => {
							child.classList.remove('in-view');
						});
					}

					// Now track when the TARGET goes out of view
					const triggerTarget = entry.target.getAttribute('reveal-trigger-target');
					if (triggerTarget) {
						const origin = document.querySelector(`[reveal-trigger-origin="${triggerTarget}"]`);
						if (origin && entry.target.classList.contains('repeat-reveal')) {
							entry.target.classList.remove('in-view');
						}
					}
				}
			});
		},
		{
			threshold: 0.15,
		}
	);
	sectionsReveal.forEach((section) => {
		observer.observe(section);
	});
});
